import type { FC } from 'react'

import { unit } from '@hcr/ui'
import { isNotNull, isNull } from '@hcr/utils'

import { useHoliday } from '../../contexts'
import { useDestinationDetailsQuery } from '../../hooks'
import { createDestinationDetailsContent } from '../../utils'
import { BookingOverviewCompact, LayoutNavigationError500 } from '../common'

import { LayoutHome } from './common'
import { HomeDestination } from './HomeDestination'
import { HomeEmpty } from './HomeEmpty'
import { HomeFallback } from './HomeFallback'
import { HomeLoading } from './HomeLoading'

const destinationDetailsContent = createDestinationDetailsContent({ slidesMargin: unit(3) })

export const Home: FC = () => {
  const holiday = useHoliday()

  const destinationDetails = useDestinationDetailsQuery(
    { destinationId: String(holiday.data.destinationId) },
    { enabled: isNotNull(holiday.data.destinationId) }
  )

  if (holiday.isError) {
    return <LayoutNavigationError500 showContextMenuButton />
  }

  if (destinationDetails.isError) {
    return <HomeFallback />
  }

  if (holiday.isSuccess && isNull(holiday.data.accommodationId) && isNull(holiday.data.destinationId)) {
    return <HomeEmpty />
  }

  if (holiday.isSuccess && isNull(holiday.data.accommodationId)) {
    return <HomeDestination />
  }

  if (holiday.isSuccess && destinationDetails.isSuccess) {
    return (
      <LayoutHome
        imageUrl={destinationDetails.data.imageUrl}
        header={<BookingOverviewCompact />}
        content={destinationDetails.data.content.map(destinationDetailsContent)}
      />
    )
  }

  return <HomeLoading />
}
